import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import styles from './Months.module.scss';
import Month from "./Month/Month";

function Months({pivot, start, end, children, disabled, pastDisabled, selectMonthHandler, availableRange, inlineStyle, t}) {

    const classes = disabled ? [styles.container, styles.disabled].join(' ') : styles.container;

    const today = moment();
    const year = pivot.format('YYYY');
    const firstMonth = moment(`${year}-01-01`);
    const lastMonth = moment(`${year}-12-01`);

    const months = [];
    const unit = 'month';
    for (let m = firstMonth.clone(); m.isSameOrBefore(lastMonth); m.add(1, unit)) {
        const current = m.clone();
        const isOutOfAvailableRange = availableRange
            ? current.isBefore(availableRange.start, unit) || current.isAfter(availableRange.end, unit)
            : false;
        const isSelected = current.isSameOrAfter(start, unit) && current.isSameOrBefore(end, unit);
        const isDisabled = disabled || isOutOfAvailableRange || (current.isBefore(today, unit) && pastDisabled);
        const isToRightSelection =  current.isSame(start, unit);
        const isToLeftSelection = current.isSame(end, unit);
        months.push(
            <Month key={current.format('MMMM')}
                   clickHandler={() => selectMonthHandler(current.clone())}
                   disabled={isDisabled}
                   toRightSelection={isToRightSelection}
                   toLeftSelection={isToLeftSelection}
                   selected={isSelected}>
                <span title={t(current.format('MMMM'))}>
                    {t(current.format('MMMM')).substring(0, 3)}
                </span>
            </Month>
        );
    }

    return (
        <div className={classes} style={inlineStyle}>
            <div className={styles.monthsContainer}>
                {months}
                {children}
            </div>
        </div>
    );
}

Months.propTypes = {
    inlineStyle: PropTypes.object,
    selectMonthHandler: PropTypes.func,
    children: PropTypes.any,
    disabled: PropTypes.bool,
    pastDisabled: PropTypes.bool,
    pivot: PropTypes.instanceOf(moment),
    start: PropTypes.instanceOf(moment),
    end: PropTypes.instanceOf(moment),
    availableRange: PropTypes.shape({
        start: PropTypes.instanceOf(moment),
        end: PropTypes.instanceOf(moment)
    }),
    t: PropTypes.func
};

Months.defaultProps = {
    inlineStyle: {},
    selectMonthHandler: () => null,
    children: null,
    disabled: false,
    pastDisabled: false,
    pivot: moment(),
    start: null,
    end: null,
    availableRange: null,
    t: str => str
};

export default Months;
